module.exports = __webpack_public_path__ + "static/img/健康体检@3x.fw.e0b6a1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/index/nav/健康体检@3x.fw.png
// module id = 779
// module chunks = 358